import { useTranslation } from 'react-i18next'

export const ModalHeaderUploadReceipt = () => {
  const { t } = useTranslation()
  
  return (
    <>
      <h3>{t("Подтверждение оплаты")}</h3>
    </>
  )
}

